export default {"src":"/_next/static/media/hexagon_background.e9e0dd73.svg","height":488,"width":533};